import { List } from 'antd';
import { observer } from 'mobx-react-lite';
import { EntityPresentation } from 'src/components/EntityPresentation/EntityPresentation';
import { MasterDetailsAside } from 'src/components/MasterDetailsPage/MasterDetailsAside';
import { MasterDetailsPage } from 'src/components/MasterDetailsPage/MasterDetailsPage';
import { LoanDtoBrief } from 'src/generated-api-client';
import { AgentLoanListItem } from 'src/pages/AgentLoansPage/AgentLoanListItem';
import { AgentLoansHeaderPanel } from 'src/pages/AgentLoansPage/AgentLoansHeaderPanel';
import { AgentLoansStore } from 'src/stores/AgentLoansStore/AgentLoansStore';

export const AgentLoansPage = observer(() => {
    return (
        <MasterDetailsPage
            pageName="agent-loans"
            store={store}
            asidePanel={<AgentLoansAsidePanel />}
            data-testid="agent-loans-page"
        >
            <EntityPresentation store={store} entityName="agent-loan" />
        </MasterDetailsPage>
    );
});

const AgentLoansAsidePanel = observer(() => {
    return (
        <MasterDetailsAside
            store={store}
            renderItem={(item: LoanDtoBrief) => {
                return (
                    <List.Item
                        key={item.id}
                        data-testid={`master-details-list-item-${item.id}`}
                    >
                        <AgentLoanListItem item={item} />
                    </List.Item>
                );
            }}
            header={<AgentLoansHeaderPanel />}
        />
    );
});

const store = AgentLoansStore;
